import React, { FC } from 'react'
import s from './RestItemPageFormat.module.sass'
import { GigAssChatOpener } from '@widgets/Common/GigAssist/components/GigAssChatOpener'
import { Notices } from '@widgets/Common/Notices'
import { useAppSelector } from '@app/model/store'
import { FloatingMenu } from '@widgets/Restaurant/FloatingMenu'
import { DefaultPageFormat } from '@widgets/Common/BottomFixedContent/components/DefaultPageFormat'
import { useIntersection } from '@shared/lib/hooks/useIntersection'

const RestItemPageFormat: FC = () => {
  const isOpenedGigaAssChat = useAppSelector((store) => store.gigAssist.chatOpen)
  const isOpenedModalFeedback = useAppSelector((store) => store.feedback.opened)
  const restaurantData = useAppSelector((store) => store.pages.rest_item.data)
  const footerVisible = useIntersection('#page-footer')

  const hasAnyBooking =
    restaurantData?.status?.open &&
    (restaurantData?.booking?.afisha?.active || restaurantData?.booking?.tomesto?.active)

  const isButtonHideAnim = isOpenedGigaAssChat || isOpenedModalFeedback || footerVisible

  return (
    <>
      {hasAnyBooking ? (
        <div className={s.wrapper}>
          <div className={s.gigass}>
            <GigAssChatOpener isHideAnim={isButtonHideAnim} mode={'fixed-short'} />
          </div>
          <Notices className={s.notices} />
          {/*
            div wrapper для FloatingMenu не удалять.
            Он не позволяет сдвинуть контент из за margin-bottom -150px больше необходимого
          */}
          <div>
            <FloatingMenu className={s.booking} />
          </div>
        </div>
      ) : (
        <DefaultPageFormat />
      )}
    </>
  )
}

export default RestItemPageFormat
